'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import { isFragment } from 'react-is';
import clsx from 'clsx';
import chainPropTypes from '@mui/utils/chainPropTypes';
import composeClasses from '@mui/utils/composeClasses';
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import Avatar, { avatarClasses } from "../Avatar/index.js";
import avatarGroupClasses, { getAvatarGroupUtilityClass } from "./avatarGroupClasses.js";
import useSlot from "../utils/useSlot.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SPACINGS = {
    small: -16,
    medium: -8
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ]
    };
    return composeClasses(slots, getAvatarGroupUtilityClass, classes);
};
var AvatarGroupRoot = styled('div', {
    name: 'MuiAvatarGroup',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return [
            _define_property({}, "& .".concat(avatarGroupClasses.avatar), styles.avatar),
            styles.root
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    return _define_property({
        display: 'flex',
        flexDirection: 'row-reverse'
    }, "& .".concat(avatarClasses.root), {
        border: "2px solid ".concat((theme.vars || theme).palette.background.default),
        boxSizing: 'content-box',
        marginLeft: 'var(--AvatarGroup-spacing, -8px)',
        '&:last-child': {
            marginLeft: 0
        }
    });
}));
var AvatarGroup = /*#__PURE__*/ React.forwardRef(function AvatarGroup(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiAvatarGroup'
    });
    var childrenProp = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, componentsProps = props.componentsProps, _props_max = props.max, max = _props_max === void 0 ? 5 : _props_max, renderSurplus = props.renderSurplus, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_spacing = props.spacing, spacing = _props_spacing === void 0 ? 'medium' : _props_spacing, total = props.total, _props_variant = props.variant, variant = _props_variant === void 0 ? 'circular' : _props_variant, other = _object_without_properties(props, [
        "children",
        "className",
        "component",
        "componentsProps",
        "max",
        "renderSurplus",
        "slotProps",
        "slots",
        "spacing",
        "total",
        "variant"
    ]);
    var clampedMax = max < 2 ? 2 : max;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        max: max,
        spacing: spacing,
        component: component,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    var children = React.Children.toArray(childrenProp).filter(function(child) {
        if (process.env.NODE_ENV !== 'production') {
            if (isFragment(child)) {
                console.error([
                    "MUI: The AvatarGroup component doesn't accept a Fragment as a child.",
                    'Consider providing an array instead.'
                ].join('\n'));
            }
        }
        return /*#__PURE__*/ React.isValidElement(child);
    });
    var totalAvatars = total || children.length;
    if (totalAvatars === clampedMax) {
        clampedMax += 1;
    }
    clampedMax = Math.min(totalAvatars + 1, clampedMax);
    var maxAvatars = Math.min(children.length, clampedMax - 1);
    var extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
    var extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : "+".concat(extraAvatars);
    var marginValue;
    if (ownerState.spacing && SPACINGS[ownerState.spacing] !== undefined) {
        marginValue = SPACINGS[ownerState.spacing];
    } else if (ownerState.spacing === 0) {
        marginValue = 0;
    } else {
        marginValue = -ownerState.spacing || SPACINGS.medium;
    }
    var _slotProps_additionalAvatar;
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            surplus: (_slotProps_additionalAvatar = slotProps.additionalAvatar) !== null && _slotProps_additionalAvatar !== void 0 ? _slotProps_additionalAvatar : componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.additionalAvatar
        }, componentsProps, slotProps)
    };
    var _useSlot = _sliced_to_array(useSlot('surplus', {
        elementType: Avatar,
        externalForwardedProps: externalForwardedProps,
        className: classes.avatar,
        ownerState: ownerState,
        additionalProps: {
            variant: variant
        }
    }), 2), SurplusSlot = _useSlot[0], surplusProps = _useSlot[1];
    return /*#__PURE__*/ _jsxs(AvatarGroupRoot, _object_spread_props(_object_spread({
        as: component,
        ownerState: ownerState,
        className: clsx(classes.root, className),
        ref: ref
    }, other), {
        style: _object_spread({
            '--AvatarGroup-spacing': "".concat(marginValue, "px")
        }, other.style),
        children: [
            extraAvatars ? /*#__PURE__*/ _jsx(SurplusSlot, _object_spread_props(_object_spread({}, surplusProps), {
                children: extraAvatarsElement
            })) : null,
            children.slice(0, maxAvatars).reverse().map(function(child) {
                return /*#__PURE__*/ React.cloneElement(child, {
                    className: clsx(child.props.className, classes.avatar),
                    variant: child.props.variant || variant
                });
            })
        ]
    }));
});
process.env.NODE_ENV !== "production" ? AvatarGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The avatars to stack.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: PropTypes.elementType,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ componentsProps: PropTypes.shape({
        additionalAvatar: PropTypes.object
    }),
    /**
   * Max avatars to show before +x.
   * @default 5
   */ max: chainPropTypes(PropTypes.number, function(props) {
        if (props.max < 2) {
            return new Error([
                'MUI: The prop `max` should be equal to 2 or above.',
                'A value below is clamped to 2.'
            ].join('\n'));
        }
        return null;
    }),
    /**
   * custom renderer of extraAvatars
   * @param {number} surplus number of extra avatars
   * @returns {React.ReactNode} custom element to display
   */ renderSurplus: PropTypes.func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: PropTypes.shape({
        additionalAvatar: PropTypes.object,
        surplus: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: PropTypes.shape({
        surplus: PropTypes.elementType
    }),
    /**
   * Spacing between avatars.
   * @default 'medium'
   */ spacing: PropTypes.oneOfType([
        PropTypes.oneOf([
            'medium',
            'small'
        ]),
        PropTypes.number
    ]),
    /**
   * @ignore
   */ style: PropTypes.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The total number of avatars. Used for calculating the number of extra avatars.
   * @default children.length
   */ total: PropTypes.number,
    /**
   * The variant to use.
   * @default 'circular'
   */ variant: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'circular',
            'rounded',
            'square'
        ]),
        PropTypes.string
    ])
} : void 0;
export default AvatarGroup;
